<template>
  <div class="d-flex justify-content-center">
    <div class="d-flex flex-wrap">
      <div v-for="card in form.cards" :key="card.id" class="col-md-5">
        <QuotationAgreementCard :card="card" :product="product" />
      </div>
    </div>
  </div>
</template>
<script>
import QuotationAgreementCard from "./QuotationAgreementCard.vue";

export default {
  created() {},
  components: {
    QuotationAgreementCard
  },
  props: {
    form: {
      type: Object
    },
    product: {
      type: String
    }
  }
};
</script>

<style></style>
